import { Route, Routes } from 'react-router-dom'
import { DDJJSuborg } from './DDJJSuborg/DDJJSuborg'
import { DeclarationHome } from './DeclarationHome/DeclarationHome'

export default function Declarations () {
  return (
    <Routes>
      <Route path="/" element={<DeclarationHome />} />
      <Route path=":id/declarations/*" element={<DDJJSuborg />} />
    </Routes>
  )
}
